<p-card>
  <ng-template pTemplate="header">
    <div class="bg-primary p-2 text-xl font-semibold">{{ product!.name }}</div>
  </ng-template>
  <div class="-mt-2 -mb-2">
    <div *ngIf="productFeatures[product!.name]">
      <ul *ngFor="let productFeature of productFeatures[product!.name]" class="mb-3 -mt-1">
        <li>{{ productFeature }}</li>
      </ul>
    </div>
    <div *ngIf="product!.marketingInformation && product!.marketingInformation.productDescription" class="mb-4">
      {{ product!.marketingInformation.productDescription }}
    </div>
    <div class="flex flex-row align-items-end">
      <div class="flex text-2xl font-semibold" *ngIf="product!.marketingInformation && product?.marketingInformation?.recurringMonthlyFee! > 0">
        {{ product!.marketingInformation.recurringMonthlyFee | currency:"EUR"}}
        <i class="fa-solid fa-asterisk vertical-align-top ml-1 text-sm text-gray-500"></i>
      </div>
      <div class="flex pl-2 flex-grow-1" *ngIf="product!.marketingInformation && product?.marketingInformation?.recurringMonthlyFee! > 0">
        monatlich
      </div>
      <div class="flex text-2xl font-semibold" *ngIf="product!.marketingInformation && product?.marketingInformation?.startFee! > 0">
        {{ product!.marketingInformation.startFee | currency:"EUR"}}
        <i class="fa-solid fa-asterisk vertical-align-top ml-1 text-sm text-gray-500"></i>
      </div>
      <div class="flex pl-2 flex-grow-1" *ngIf="product!.marketingInformation && product?.marketingInformation?.startFee! > 0">
        einmalig
      </div>
      <div class="flex">
        <button type="button" class="p-button-danger" icon="fa-solid fa-minus" pButton label="entfernen" (click)="rem.emit(product!)" *ngIf="isSelected"></button>
        <button type="button" icon="fa-solid fa-plus" pButton label="hinzufügen" (click)="add.emit(product!)" *ngIf="!isSelected" [disabled]="isDisabled"></button>
      </div>
    </div>
  </div>
</p-card>
